import { render, staticRenderFns } from "./Spoiler.vue?vue&type=template&id=1541f667"
import script from "./Spoiler.vue?vue&type=script&lang=js"
export * from "./Spoiler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports